module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-576w.4d4a959e.jpg";